import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import useUserStore from "../../../../../utils/storeApp";
import { Column } from "primereact/column";
import { useReactToPrint } from "react-to-print";
import ReportsDropdown from "../../ReportsDropdown";
import { DownloadTableExcel } from "react-export-table-to-excel";

const ListUserAccountHistory = () => {
  const navigate = useNavigate();
  const { sharedObject, userRole, userToken, SetSharedObject } = useUserStore(
    (state) => ({
      sharedObject: state.sharedObject,
      SetSharedObject: state.SetSharedObject,
      userRole: state.userRole,
      userToken: state.userToken,
    })
  );
  const [userObj, setUserObj] = useState([]);
  const [processing, SetProcessing] = useState(false);
  useEffect(() => {
    let obj = sharedObject.UserActiviyHistory;
    if (obj && Object.keys(obj).length > 0) {
      setUserObj(obj.List);
    }
  }, [sharedObject.UserActiviyHistory]);
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const refreshPage = () => {
    setUserObj(sharedObject.UserActiviyHistory.List);
  };

  const TimeStamp = (dt) => {
    return dt.timeStamp ? new Date(dt.timeStamp).toLocaleString() : null;
  };

  return (
    <div className="ListUserAccountHistory">
      <div className="HeaderUserActivityTool">
        <header>
          <div className="btnback-container-1">
            <a
              href={"javascript:void(0);"}
              onClick={(e) => navigate("/user-activity")}
            >
              <i className="bi bi-arrow-left-square-fill spacer-margin5"></i>
            </a>
          </div>
          <div className="title-label4">
            {sharedObject?.UserActiviyHistory?.Name} Activity History
          </div>
          <aside className="mid-header-bar spacer-inline sp-mx5">
            <ReportsDropdown />
            <button
              className="btn btn-outline-dark sp-margin5 btn-reports-sm"
              data-target="#userActivityHistorySearchModal"
              data-toggle="modal"
              title="Search"
              alt="search for message forwarding"
            >
              <i className="bi bi-search" alt="search icon"></i>
            </button>
            <span className="SharedTools">
              <DownloadTableExcel
                filename="UserHistoryReport"
                sheet="Reports"
                currentTableRef={componentRef.current}
              >
                <button
                  className="btn btn-outline-dark sp-margin5 btn-reports-sm"
                  title="File Download"
                >
                  <i className="bi bi-download" alt="file download icon"></i>
                </button>
              </DownloadTableExcel>
              <button
                className="btn btn-outline-dark sp-margin5 btn-reports-sm"
                title="Refresh Page"
                onClick={(e) => {
                  if (userObj?.length > 0) refreshPage();
                }}
              >
                <i
                  className="bi bi-arrow-clockwise"
                  alt="refresh page icon"
                ></i>
              </button>
              <button
                className="btn btn-outline-dark sp-margin5 btn-reports-sm"
                title="Print page"
                onClick={(e) => {
                  if (userObj?.length > 0) {
                    handlePrint();
                  }
                }}
              >
                <i className="bi bi-printer" alt="printer icon"></i>
              </button>
            </span>
          </aside>
        </header>
      </div>
      <section className="grid-layout" ref={componentRef}>
        <div>
          {userObj?.length > 0 ? (
            <div id="SentMessageReport">
              <DataTable
                value={userObj}
                paginator
                rows={10}
                rowsPerPageOptions={[10, 25, 50]}
                tableStyle={{ minWidth: "50rem" }}
                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                currentPageReportTemplate="{first} to {last} of {totalRecords}"
                dataKey="Id"
                columnResizeMode="expand"
                resizableColumns
                scrollable
              >
                <Column
                  field="eventType"
                  header="Event Type"
                  className="w-md5"
                  sortable
                ></Column>
                <Column
                  field="actor"
                  header="Performed By"
                  className="w-md6"
                  sortable
                ></Column>
                <Column
                  field="timeStamp"
                  header="Event Date"
                  className="w-md8"
                  body={TimeStamp}
                  sortable
                ></Column>
                <Column field="note" header="Note" sortable></Column>
              </DataTable>
              {/* <Paginator
                          first={firstHistory}
                          rows={rowsHistory}
                          totalRecords={historyData?.length}
                          onPageChange={onPageChangeHistory}
                        />
                        <span className="">
                          {firstHistory} - {lastHistory} of{" "}
                          {historyData?.length}
                        </span> */}
            </div>
          ) : (
            <section className="empty-grid">
              There are currently no search results.
            </section>
          )}
        </div>
      </section>
      {/*  ) : null}*/}
    </div>
  );
};

ListUserAccountHistory.propTypes = {};

ListUserAccountHistory.defaultProps = {};

export default ListUserAccountHistory;
